import React from "react";
import "./card.scss";
import { CardIcon } from "../../icons/svg";

const Card = ({ formTitle, handleClickOpen}) => {

  return (
    <>
      <div className="formCard " onClick={handleClickOpen}>
        <div className="cardIcon">
        <CardIcon />
        </div>
        <div className="shordDesc">
          <h3 className="h3">{formTitle}</h3>
          <p>Fill the form to place order</p>
        </div>
      
      </div>

    </>
  );
};

export default Card;
